var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgFolder = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#000",
  d: "M0 3c0-1.103.897-2 2-2h4.128a2.25 2.25 0 0 1 1.59.66L9.06 3H14c1.103 0 2 .897 2 2v8c0 1.103-.897 2-2 2H2c-1.103 0-2-.897-2-2V3Zm2-.5c-.275 0-.5.225-.5.5v10c0 .275.225.5.5.5h12c.275 0 .5-.225.5-.5V5c0-.275-.225-.5-.5-.5H8.956c-.331 0-.65-.131-.884-.366L6.659 2.72a.75.75 0 0 0-.53-.219H2Z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgFolder);
export default ForwardRef;